module.exports = __webpack_public_path__ + "img/banner_doudian.bd0df5d9.png";